
import { Union, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { PortType, Port, ComponentType, Port_$reflection, Component_$reflection, Connection_$reflection } from "../Common/CommonTypes.js";
import { union_type, tuple_type, record_type, int32_type, class_type, string_type, list_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { length, tryHead, exists, tryPick, contains, forAll, tryFind as tryFind_1, tail, head, isEmpty, cons, fold, filter, collect, tryItem, tryFindIndex, append, map as map_1, initialize, empty, singleton, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { curry3, curry2, comparePrimitives, stringHash, compare as compare_1, Exception, equals, int32ToString } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { FSharpMap__get_IsEmpty, filter as filter_1, empty as empty_1, FSharpMap__TryFind, FSharpMap__Add, tryFind, toList, FSharpMap__get_Item, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { PortRmInfo, SimulationError, SimulationErrorType } from "./SimGraphTypes.js";
import { concat, toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { singleton as singleton_1, append as append_1, delay, toList as toList_1 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { StringModule_Concat, MapModule_KeysL } from "../Common/EEExtensions.js";
import { ofSeq } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { flatten, value as value_2, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { signatureOfInstanceWithCertainty } from "./CanvasExtractor.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { ResultList_sequence } from "../Common/Helpers.js";
import { inferConnectionsWidth } from "../Common/WidthInferer.js";

/**
 * Return all the Ids of all input ports across all components.
 * Return also the ComponentId which may be used in error messages.
 */
export class MapData extends Record {
    constructor(Connections, Components, LabComp, LabGroup, LabInputPorts, LabOutputPorts, LabTargetConns, OtherTargetConns, LabSourceConns, OtherSourceConns, OtherInputPorts, OtherOutputPorts, ToComp, ToInputPort, ToOutputPort) {
        super();
        this.Connections = Connections;
        this.Components = Components;
        this.LabComp = LabComp;
        this.LabGroup = LabGroup;
        this.LabInputPorts = LabInputPorts;
        this.LabOutputPorts = LabOutputPorts;
        this.LabTargetConns = LabTargetConns;
        this.OtherTargetConns = OtherTargetConns;
        this.LabSourceConns = LabSourceConns;
        this.OtherSourceConns = OtherSourceConns;
        this.OtherInputPorts = OtherInputPorts;
        this.OtherOutputPorts = OtherOutputPorts;
        this.ToComp = ToComp;
        this.ToInputPort = ToInputPort;
        this.ToOutputPort = ToOutputPort;
    }
}

export function MapData_$reflection() {
    return record_type("CanvasStateAnalyser.MapData", [], MapData, () => [["Connections", list_type(Connection_$reflection())], ["Components", list_type(Component_$reflection())], ["LabComp", list_type(Component_$reflection())], ["LabGroup", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(Component_$reflection())])], ["LabInputPorts", list_type(Port_$reflection())], ["LabOutputPorts", list_type(Port_$reflection())], ["LabTargetConns", list_type(Connection_$reflection())], ["OtherTargetConns", list_type(Connection_$reflection())], ["LabSourceConns", list_type(Connection_$reflection())], ["OtherSourceConns", list_type(Connection_$reflection())], ["OtherInputPorts", list_type(Port_$reflection())], ["OtherOutputPorts", list_type(Port_$reflection())], ["ToComp", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Component_$reflection()])], ["ToInputPort", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Port_$reflection()])], ["ToOutputPort", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Port_$reflection()])]]);
}

/**
 * Input and Output names of the ports depending on their ComponentType
 */
export function portNames(componentType) {
    switch (componentType.tag) {
        case 9:
            return [ofArray(["SEL", "DATA"]), ofArray(["0", "1", "2", "3"])];
        case 17:
            return [ofArray(["CIN", "P", "Q"]), ofArray(["SUM ", "COUT"])];
        case 18:
            return [ofArray(["P", "Q"]), ofArray(["SUM ", "COUT"])];
        case 20:
            return [ofArray(["P", "Q"]), singleton("SUM ")];
        case 19:
            return [ofArray(["CIN", "P", "Q"]), singleton("SUM ")];
        case 33:
            return [singleton("D"), singleton("Q")];
        case 34:
            return [ofArray(["D", "EN"]), singleton("Q")];
        case 35:
            return [ofArray(["D", "LOAD", "EN"]), singleton("Q")];
        case 37:
            return [ofArray(["D", "LOAD"]), singleton("Q")];
        case 36:
            return [singleton("EN"), singleton("Q")];
        case 38:
            return [empty(), singleton("Q")];
        case 40:
        case 39:
            return [singleton("ADDR"), singleton("DOUT")];
        case 41:
            return [ofArray(["ADDR", "DIN", "WEN"]), singleton("DOUT")];
        case 42:
            return [ofArray(["ADDR", "DIN", "WEN"]), singleton("DOUT")];
        case 31:
            return [singleton("D"), singleton("Q")];
        case 32:
            return [ofArray(["D", "EN"]), singleton("Q")];
        case 11:
            return [ofArray(["0", "1", "SEL"]), singleton("OUT")];
        case 29: {
            const nInp = componentType.fields[0] | 0;
            return [initialize(nInp, (i) => ((i === 0) ? "LSB" : ((i === (nInp - 1)) ? "MSB" : ""))), singleton("OUT")];
        }
        case 30:
            return [singleton("IN"), empty()];
        case 12:
            return [ofArray(["0", "1", "2", "3", "SEL"]), singleton("OUT")];
        case 13:
            return [ofArray(["0", "1", "2", "3", "4", "5", "6", "7", "SEL"]), singleton("OUT")];
        case 14:
            return [ofArray(["DATA", "SEL"]), ofArray(["0", "1"])];
        case 15:
            return [ofArray(["DATA", "SEL"]), ofArray(["0", "1", "2", "3"])];
        case 16:
            return [ofArray(["DATA", "SEL"]), ofArray(["0", "1", "2", "3", "4", "5", "6", "7"])];
        case 21:
        case 22:
        case 24:
            return [ofArray(["P", "Q"]), singleton("OUT")];
        case 23:
        case 25:
            return [singleton("IN"), singleton("OUT")];
        case 46:
            return [ofArray(["IN", "SHIFT"]), singleton("OUT")];
        case 26: {
            const x = componentType.fields[0];
            return [map_1((tuple) => tuple[0], x.InputLabels), map_1((tuple_1) => tuple_1[0], x.OutputLabels)];
        }
        case 50:
        case 51:
        case 52:
        case 53:
            return [empty(), empty()];
        case 54: {
            const n_5 = componentType.fields[0] | 0;
            return [initialize(n_5, (i_1) => ((i_1 === 0) ? "LSB" : ((i_1 === (n_5 - 1)) ? "MSB" : ""))), singleton("OUT")];
        }
        case 55:
            return [append(initialize(componentType.fields[0], int32ToString), singleton("SEL")), singleton("OUT")];
        default:
            return [empty(), empty()];
    }
}

export function getPortName(comp, port) {
    const pNames = portNames(comp.Type);
    const getIdx = (pList) => {
        const _arg = tryFindIndex((po) => equals(po.Id, port.Id), pList);
        if (_arg == null) {
            throw new Exception("getPortName: Port not contained in given list");
        }
        else {
            return _arg | 0;
        }
    };
    let _arg_1;
    if (port.PortType.tag === 1) {
        tryFindIndex((po_1) => equals(po_1.Id, port.Id), comp.OutputPorts);
        _arg_1 = tryItem(getIdx(comp.OutputPorts), pNames[1]);
    }
    else {
        _arg_1 = tryItem(getIdx(comp.InputPorts), pNames[0]);
    }
    if (_arg_1 == null) {
        return "";
    }
    else {
        return _arg_1;
    }
}

function getAllInputPortIds(components) {
    return collect((comp) => map_1((port) => [port.Id, comp.Id], comp.InputPorts), components);
}

function getAllOutputPortIds(components) {
    return collect((comp) => map_1((port) => [port.Id, comp.Id], comp.OutputPorts), components);
}

function genMaps(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const conns = _arg[1];
    const comps = _arg[0];
    const labComps = filter((co) => equals(co.Type, ComponentType.IOLabel), comps);
    const idToComp = ofList(map_1((co_1) => [co_1.Id, co_1], comps), {
        Compare: (x, y) => (compare_1(x, y) | 0),
    });
    const splitBy = (pred, lst) => fold((tupledArg, x_1) => {
        const is = tupledArg[0];
        const isNot = tupledArg[1];
        if (pred(x_1)) {
            return [cons(x_1, is), isNot];
        }
        else {
            return [is, cons(x_1, isNot)];
        }
    }, [empty(), empty()], lst);
    const patternInput = splitBy((c) => equals(FSharpMap__get_Item(idToComp, c.Target.HostId).Type, ComponentType.IOLabel), conns);
    const patternInput_1 = splitBy((c_1) => equals(FSharpMap__get_Item(idToComp, c_1.Source.HostId).Type, ComponentType.IOLabel), conns);
    const normalise = (p) => (new Port(p.Id, undefined, p.PortType, p.HostId));
    const normaliseL = (pL) => map_1(normalise, pL);
    const idToInputPort = ofList(map_1((po) => [po.Id, normalise(po)], collect((co_2) => co_2.InputPorts, comps)), {
        Compare: (x_2, y_1) => (compare_1(x_2, y_1) | 0),
    });
    const idToOutputPort = ofList(map_1((po_1) => [po_1.Id, normalise(po_1)], collect((co_3) => co_3.OutputPorts, comps)), {
        Compare: (x_3, y_2) => (compare_1(x_3, y_2) | 0),
    });
    const otherInputPorts = collect((co_5) => normaliseL(co_5.InputPorts), filter((co_4) => !equals(co_4.Type, ComponentType.IOLabel), comps));
    const otherOutputPorts = collect((co_7) => normaliseL(co_7.OutputPorts), filter((co_6) => !equals(co_6.Type, ComponentType.IOLabel), comps));
    return new MapData(conns, comps, labComps, ofList(List_groupBy((co_8) => co_8.Label, labComps, {
        Equals: (x_4, y_3) => (x_4 === y_3),
        GetHashCode: (x_4) => (stringHash(x_4) | 0),
    }), {
        Compare: (x_5, y_4) => (comparePrimitives(x_5, y_4) | 0),
    }), collect((co_9) => normaliseL(co_9.InputPorts), labComps), collect((co_10) => normaliseL(co_10.OutputPorts), labComps), patternInput[0], patternInput[1], patternInput_1[0], patternInput_1[1], otherInputPorts, otherOutputPorts, idToComp, idToInputPort, idToOutputPort);
}

function checkPortTypesAreConsistent(canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    const checkComponentPorts = (ports_mut, correctType_mut) => {
        checkComponentPorts:
        while (true) {
            const ports = ports_mut, correctType = correctType_mut;
            if (!isEmpty(ports)) {
                if (equals(head(ports).PortNumber, undefined)) {
                    return new SimulationError(new SimulationErrorType(/* PortNumMissing */ 0, [correctType]), undefined, singleton(head(ports).HostId), empty());
                }
                else if (!equals(head(ports).PortType, correctType)) {
                    return new SimulationError(new SimulationErrorType(/* WrongPortType */ 1, [correctType, head(ports)]), undefined, singleton(head(ports).HostId), empty());
                }
                else {
                    ports_mut = tail(ports);
                    correctType_mut = correctType;
                    continue checkComponentPorts;
                }
            }
            else {
                return undefined;
            }
            break;
        }
    };
    const checkComponentsPorts = (components_mut) => {
        checkComponentsPorts:
        while (true) {
            const components = components_mut;
            if (!isEmpty(components)) {
                const comp = head(components);
                const matchValue = checkComponentPorts(comp.InputPorts, PortType.Input);
                const matchValue_1 = checkComponentPorts(comp.OutputPorts, PortType.Output);
                let matchResult, err;
                if (matchValue == null) {
                    if (matchValue_1 == null) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 0;
                        err = matchValue_1;
                    }
                }
                else {
                    matchResult = 0;
                    err = matchValue;
                }
                switch (matchResult) {
                    case 0:
                        return err;
                    default: {
                        components_mut = tail(components);
                        continue checkComponentsPorts;
                    }
                }
            }
            else {
                return undefined;
            }
            break;
        }
    };
    const checkConnectionPort = (port_4, correctType_1, connId) => {
        const matchValue_3 = equals(port_4.PortType, correctType_1);
        const matchValue_4 = port_4.PortNumber;
        if (matchValue_3) {
            if (matchValue_4 == null) {
                return undefined;
            }
            else {
                return new SimulationError(new SimulationErrorType(/* ConnTypeHasNum */ 2, [correctType_1, matchValue_4]), undefined, singleton(port_4.HostId), singleton(connId));
            }
        }
        else {
            return new SimulationError(new SimulationErrorType(/* WrongPortType */ 1, [correctType_1, port_4]), undefined, singleton(port_4.HostId), singleton(connId));
        }
    };
    const checkConnectionsPorts = (connections_mut) => {
        checkConnectionsPorts:
        while (true) {
            const connections = connections_mut;
            if (!isEmpty(connections)) {
                const conn = head(connections);
                const matchValue_6 = checkConnectionPort(conn.Source, PortType.Output, conn.Id);
                const matchValue_7 = checkConnectionPort(conn.Target, PortType.Input, conn.Id);
                let matchResult_1, err_1;
                if (matchValue_6 == null) {
                    if (matchValue_7 == null) {
                        matchResult_1 = 1;
                    }
                    else {
                        matchResult_1 = 0;
                        err_1 = matchValue_7;
                    }
                }
                else {
                    matchResult_1 = 0;
                    err_1 = matchValue_6;
                }
                switch (matchResult_1) {
                    case 0:
                        return err_1;
                    default: {
                        connections_mut = tail(connections);
                        continue checkConnectionsPorts;
                    }
                }
            }
            else {
                return undefined;
            }
            break;
        }
    };
    const matchValue_9 = checkComponentsPorts(canvasState[0]);
    const matchValue_10 = checkConnectionsPorts(canvasState[1]);
    let matchResult_2, err_2;
    if (matchValue_9 == null) {
        if (matchValue_10 == null) {
            matchResult_2 = 1;
        }
        else {
            matchResult_2 = 0;
            err_2 = matchValue_10;
        }
    }
    else {
        matchResult_2 = 0;
        err_2 = matchValue_9;
    }
    switch (matchResult_2) {
        case 0:
            return err_2;
        default:
            return undefined;
    }
}

function checkEvery(counts, cond) {
    return fold((maybeErr, tupledArg) => {
        const _arg = tupledArg[1];
        const count = _arg[1] | 0;
        if (maybeErr == null) {
            if (cond(count)) {
                return undefined;
            }
            else {
                return [tupledArg[0], map_1((conn) => conn.Id, _arg[0]), count];
            }
        }
        else {
            return maybeErr;
        }
    }, undefined, toList(counts));
}

function countPortsConnections(conns, connMap, bins) {
    const countPortsConnections$0027 = (conns_1_mut, counts_mut) => {
        countPortsConnections$0027:
        while (true) {
            const conns_1 = conns_1_mut, counts = counts_mut;
            let key_1, matchValue;
            if (!isEmpty(conns_1)) {
                const conn = head(conns_1);
                conns_1_mut = tail(conns_1);
                counts_mut = ((key_1 = connMap(conn), (matchValue = tryFind(key_1, counts), (matchValue == null) ? counts : FSharpMap__Add(counts, key_1, [matchValue[0] + 1, cons(conn, matchValue[1])]))));
                continue countPortsConnections$0027;
            }
            else {
                return ofList(map_1((tupledArg) => {
                    const _arg = tupledArg[1];
                    return [tupledArg[0], [_arg[1], _arg[0]]];
                }, toList(counts)), {
                    Compare: (x, y) => (compare_1(x, y) | 0),
                });
            }
            break;
        }
    };
    return countPortsConnections$0027(conns, ofList(map_1((b) => [b, [0, empty()]], bins), {
        Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
    }));
}

function checkCounts(conns, connMap, bins, binMap, cond) {
    return checkEvery(countPortsConnections(conns, connMap, bins), cond);
}

export function getPortNum(pList, port) {
    const _arg = tryFind_1((po) => equals(po.Id, port.Id), pList);
    if (_arg == null) {
        return toFail(printf("port should be in given port list"));
    }
    else {
        return _arg.PortNumber;
    }
}

export function getRmInfoData(m, port) {
    const parentComp = FSharpMap__get_Item(m.ToComp, port.HostId);
    return [parentComp, getPortName(parentComp, new Port(port.Id, getPortNum(equals(port.PortType, PortType.Input) ? parentComp.InputPorts : parentComp.OutputPorts, port), port.PortType, port.HostId))];
}

function getInPortRmInfo(m, counts, port) {
    const patternInput = getRmInfoData(m, port);
    const portName = patternInput[1];
    const parentComp = patternInput[0];
    const checkAllPorts = (cond, ports) => forAll((port_1) => cond(FSharpMap__get_Item(counts, port_1.Id)[1])(port_1), ports);
    const condDisconnected = (count, port_2) => {
        if (count === 0) {
            return true;
        }
        else {
            return false;
        }
    };
    const condSelDisconnected = (portNumSelection, count_1, port_3) => {
        if (contains(portName, portNumSelection, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        })) {
            return condDisconnected(count_1, port_3);
        }
        else {
            return true;
        }
    };
    const matchValue_1 = parentComp.Type;
    switch (matchValue_1.tag) {
        case 17:
            if (portName === "CIN") {
                return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* NbitsAdderNoCin */ 18, [matchValue_1.fields[0]])]);
            }
            else {
                return PortRmInfo.Unremovable;
            }
        case 19:
            if (portName === "CIN") {
                return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* NbitsAdderNoCinCout */ 20, [matchValue_1.fields[0]])]);
            }
            else {
                return PortRmInfo.Unremovable;
            }
        case 36:
            return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* CounterNoEnableLoad */ 38, [matchValue_1.fields[0]])]);
        case 37:
            if (checkAllPorts(curry2(condDisconnected), parentComp.InputPorts)) {
                return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* CounterNoEnableLoad */ 38, [matchValue_1.fields[0]])]);
            }
            else {
                return PortRmInfo.Unremovable;
            }
        case 35: {
            const w_4 = matchValue_1.fields[0] | 0;
            const isDAndLoadDisconnected = checkAllPorts(curry3(condSelDisconnected)(ofArray(["D", "LOAD"])), parentComp.InputPorts);
            const isEnDisconnected = checkAllPorts(curry3(condSelDisconnected)(singleton("EN")), parentComp.InputPorts);
            let matchResult;
            switch (portName) {
                case "D": {
                    if (isDAndLoadDisconnected) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case "LOAD": {
                    if (isDAndLoadDisconnected) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case "EN": {
                    if (isEnDisconnected) {
                        matchResult = 2;
                    }
                    else {
                        matchResult = 3;
                    }
                    break;
                }
                default:
                    if (isDAndLoadDisconnected) {
                        matchResult = 5;
                    }
                    else if (isEnDisconnected) {
                        matchResult = 5;
                    }
                    else {
                        matchResult = 4;
                    }
            }
            switch (matchResult) {
                case 0:
                    return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* CounterNoLoad */ 36, [w_4])]);
                case 1:
                    return PortRmInfo.Unremovable;
                case 2:
                    return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* CounterNoEnable */ 37, [w_4])]);
                case 3:
                    return PortRmInfo.Unremovable;
                case 4:
                    return PortRmInfo.Unremovable;
                default:
                    throw new Exception("Ports can never be connected like this");
            }
        }
        default:
            return PortRmInfo.Unremovable;
    }
}

function getOutPortRmInfo(m, counts, port) {
    const patternInput = getRmInfoData(m, port);
    const portName = patternInput[1];
    const matchValue = patternInput[0].Type;
    switch (matchValue.tag) {
        case 17:
            if (portName === "COUT") {
                return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* NbitsAdderNoCout */ 19, [matchValue.fields[0]])]);
            }
            else {
                return PortRmInfo.Unremovable;
            }
        case 18:
            if (portName === "COUT") {
                return new PortRmInfo(/* Removable */ 1, [new ComponentType(/* NbitsAdderNoCinCout */ 20, [matchValue.fields[0]])]);
            }
            else {
                return PortRmInfo.Unremovable;
            }
        default:
            return PortRmInfo.Unremovable;
    }
}

function getInErrType(count, port, rmInfo) {
    return new SimulationErrorType(/* InputConnError */ 11, [count, port, rmInfo]);
}

export function getOutErrType(count, port, rmInfo) {
    return new SimulationErrorType(/* OutputConnError */ 12, [count, port, rmInfo]);
}

function checkPortConnections(m, connMap, bins, cond, pidMap, rmInfoGen, errTypeGen) {
    const counts = countPortsConnections(m.Connections, connMap, map_1((port) => port.Id, bins));
    const matchValue = checkEvery(counts, cond);
    if (matchValue == null) {
        return undefined;
    }
    else {
        const count = matchValue[2] | 0;
        const connsAffected = matchValue[1];
        const port_1 = pidMap(matchValue[0]);
        return new SimulationError(errTypeGen(count, port_1, rmInfoGen(m, counts, port_1)), undefined, singleton(port_1.HostId), connsAffected);
    }
}

function checkConns(conns, m) {
    let tupledArg;
    const compOfPort = (p) => FSharpMap__get_Item(m.ToComp, p.HostId);
    const option_1 = tryPick((conn) => {
        const s = compOfPort(conn.Source);
        const t = compOfPort(conn.Target);
        if (equals(s.Type, ComponentType.IOLabel) && equals(t.Type, ComponentType.IOLabel)) {
            return [s, t, conn];
        }
        else {
            return undefined;
        }
    }, conns);
    if (option_1 != null) {
        return (tupledArg = option_1, new SimulationError(SimulationErrorType.LabelConnect, undefined, ofArray([tupledArg[0].Id, tupledArg[1].Id]), singleton(tupledArg[2].Id)));
    }
    else {
        return undefined;
    }
}

function checkPortsAreConnectedProperly(canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    const m = genMaps(canvasState[0], canvasState[1]);
    const labMap = (lab) => FSharpMap__get_Item(m.LabGroup, lab);
    return tryPick((x_3) => x_3, toList_1(delay(() => append_1(singleton_1(checkPortConnections(m, (conn) => conn.Target.Id, m.OtherInputPorts, (y) => (1 === y), (pid) => FSharpMap__get_Item(m.ToInputPort, pid), getInPortRmInfo, getInErrType)), delay(() => {
        let matchValue, connsAffected;
        return append_1((matchValue = checkCounts(m.LabTargetConns, (conn_1) => FSharpMap__get_Item(m.ToComp, conn_1.Target.HostId).Label, MapModule_KeysL(m.LabGroup), labMap, (y_1) => (1 === y_1)), (matchValue == null) ? singleton_1(undefined) : ((connsAffected = matchValue[1], singleton_1(new SimulationError(new SimulationErrorType(/* LabelConnError */ 13, [matchValue[2]]), undefined, map_1((comp) => comp.Id, labMap(matchValue[0])), connsAffected))))), delay(() => append_1(singleton_1(checkPortConnections(m, (conn_2) => conn_2.Source.Id, m.OtherOutputPorts, (y_2) => (0 < y_2), (pid_1) => FSharpMap__get_Item(m.ToOutputPort, pid_1), getOutPortRmInfo, getOutErrType)), delay(() => singleton_1(checkConns(m.Connections, m))))));
    })))));
}

function checkIOLabels(canvasState_, canvasState__1) {
    const checkDuplicate = (comps_mut, map_mut, ioType_mut) => {
        checkDuplicate:
        while (true) {
            const comps = comps_mut, map = map_mut, ioType = ioType_mut;
            if (!isEmpty(comps)) {
                const comps$0027 = tail(comps);
                const comp = head(comps);
                const matchValue = FSharpMap__TryFind(map, comp.Label);
                if (matchValue != null) {
                    if (equals(matchValue, comp.Id)) {
                        const compId_1 = matchValue;
                        comps_mut = comps$0027;
                        map_mut = map;
                        ioType_mut = ioType;
                        continue checkDuplicate;
                    }
                    else {
                        const compId_2 = matchValue;
                        return new SimulationError(new SimulationErrorType(/* LabelDuplicate */ 4, [ioType, comp.Label]), undefined, ofArray([comp.Id, compId_2]), empty());
                    }
                }
                else {
                    comps_mut = comps$0027;
                    map_mut = map;
                    ioType_mut = ioType;
                    continue checkDuplicate;
                }
            }
            else {
                return undefined;
            }
            break;
        }
    };
    const toMap = (comps_1) => ofList(map_1((comp_1) => [comp_1.Label, comp_1.Id], comps_1), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const components = canvasState_;
    const inputs = filter((comp_2) => {
        if (comp_2.Type.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, components);
    const outputs = filter((comp_3) => {
        const matchValue_2 = comp_3.Type;
        switch (matchValue_2.tag) {
            case 1:
            case 50:
            case 51:
                return true;
            default:
                return false;
        }
    }, components);
    filter((comp_4) => {
        if (comp_4.Type.tag === 3) {
            return true;
        }
        else {
            return false;
        }
    }, components);
    const matchValue_4 = checkDuplicate(inputs, toMap(inputs), "Input");
    const matchValue_5 = checkDuplicate(outputs, toMap(outputs), "Output");
    let matchResult, err;
    if (matchValue_4 == null) {
        if (matchValue_5 == null) {
            matchResult = 1;
        }
        else {
            matchResult = 0;
            err = matchValue_5;
        }
    }
    else {
        matchResult = 0;
        err = matchValue_4;
    }
    switch (matchResult) {
        case 0:
            return err;
        default:
            return undefined;
    }
}

export class CustomComponentError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoSheet", "BadInputs", "BadOutputs"];
    }
}

export function CustomComponentError_$reflection() {
    return union_type("CanvasStateAnalyser.CustomComponentError", [], CustomComponentError, () => [[["Item", string_type]], [["ComponentSheet", string_type], ["InstLists", list_type(tuple_type(string_type, int32_type))], ["CompLists", list_type(tuple_type(string_type, int32_type))]], [["ComponentSheet", string_type], ["InstLists", list_type(tuple_type(string_type, int32_type))], ["CompLists", list_type(tuple_type(string_type, int32_type))]]]);
}

/**
 * Check a single custom component for correct I/Os, resolving parameters if necessary.
 */
export function checkCustomComponentForOkIOs(c, args, sheets) {
    let sheet_1, patternInput, instanceBindings, widthsKnown, resolvedOutputs, resolvedInputs, names, arg_3, arg_7;
    const name = args.Name;
    const compare = (labs1, labs2) => ofSeq(labs1, {
        Compare: (x, y) => (compare_1(x, y) | 0),
    }).Equals(ofSeq(labs2, {
        Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
    }));
    let _arg;
    const option_3 = tryFind_1((sheet) => (sheet.Name === name), sheets);
    _arg = ((option_3 != null) ? ((sheet_1 = option_3, (patternInput = defaultArg((instanceBindings = defaultArg(args.ParameterBindings, empty_1({
        Compare: (x_2, y_2) => (compare_1(x_2, y_2) | 0),
    })), signatureOfInstanceWithCertainty(sheets, empty_1({
        Compare: (x_3, y_3) => (compare_1(x_3, y_3) | 0),
    }), name, instanceBindings)), [[sheet_1.InputLabels, sheet_1.OutputLabels], true]), (widthsKnown = patternInput[1], (resolvedOutputs = patternInput[0][1], (resolvedInputs = patternInput[0][0], (names = ((labs) => map_1((tuple) => tuple[0], labs)), [[resolvedInputs, resolvedOutputs], widthsKnown ? compare(resolvedInputs, args.InputLabels) : ((arg_3 = names(args.InputLabels), compare(names(resolvedInputs), arg_3))), widthsKnown ? compare(resolvedOutputs, args.OutputLabels) : ((arg_7 = names(args.OutputLabels), compare(names(resolvedOutputs), arg_7)))]))))))) : undefined);
    if (_arg != null) {
        if (_arg[1]) {
            if (_arg[2]) {
                return new FSharpResult$2(/* Ok */ 0, [undefined]);
            }
            else {
                const outs = _arg[0][1];
                return new FSharpResult$2(/* Error */ 1, [[c, new CustomComponentError(/* BadOutputs */ 2, [name, outs, args.OutputLabels])]]);
            }
        }
        else {
            const ins = _arg[0][0];
            return new FSharpResult$2(/* Error */ 1, [[c, new CustomComponentError(/* BadInputs */ 1, [name, ins, args.InputLabels])]]);
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [[c, new CustomComponentError(/* NoSheet */ 0, [name])]]);
    }
}

/**
 * Custom components have I/Os which are the same (names) as the I/Os in the corresponding sheet
 * This can change if a sheet made into a custom component is edited
 * We do this check whenever a new sheet is opened
 */
export function checkCustomComponentsOk(_arg1_, _arg1__1, sheets) {
    const error = (c, t) => (new SimulationError(t, undefined, singleton(c.Id), empty()));
    const disp = (portL) => {
        const arg = StringModule_Concat(" , ", map_1((tuple) => tuple[0], portL));
        return toText(printf("%s"))(arg);
    };
    const _arg_2 = ResultList_sequence(collect((_arg_1) => {
        if (_arg_1.Type.tag === 26) {
            return singleton(checkCustomComponentForOkIOs(_arg_1, _arg_1.Type.fields[0], sheets));
        }
        else {
            return empty();
        }
    }, _arg1_));
    if (_arg_2.tag === 1) {
        switch (_arg_2.fields[0][1].tag) {
            case 1:
                return error(_arg_2.fields[0][0], new SimulationErrorType(/* InPortMismatch */ 9, [_arg_2.fields[0][1].fields[0], disp(_arg_2.fields[0][1].fields[1]), disp(_arg_2.fields[0][1].fields[2])]));
            case 2:
                return error(_arg_2.fields[0][0], new SimulationErrorType(/* OutPortMismatch */ 10, [_arg_2.fields[0][1].fields[0], disp(_arg_2.fields[0][1].fields[1]), disp(_arg_2.fields[0][1].fields[2])]));
            default:
                return error(_arg_2.fields[0][0], new SimulationErrorType(/* MissingSheet */ 8, [_arg_2.fields[0][1].fields[0]]));
        }
    }
    else {
        return undefined;
    }
}

/**
 * Check whether Adders have a NotConnected component connected to their COUT
 * this is unnecessary since it can be disabled via its options
 */
export function checkAdderUnnecessaryNC(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const conns = _arg[1];
    const comps = _arg[0];
    const affectedPorts = filter((port_1) => (value_2(port_1.PortNumber) !== 0), collect((comp_2) => filter((port) => exists((conn) => {
        if (equals(conn.Source.Id, port.Id)) {
            return exists((comp) => {
                if (equals(comp.Id, conn.Target.HostId)) {
                    return equals(comp.Type, ComponentType.NotConnected);
                }
                else {
                    return false;
                }
            }, comps);
        }
        else {
            return false;
        }
    }, conns), comp_2.OutputPorts), filter((_arg_1) => {
        const matchValue = _arg_1.Type;
        switch (matchValue.tag) {
            case 17:
            case 18:
                return true;
            default:
                return false;
        }
    }, comps)));
    if (isEmpty(affectedPorts)) {
        return undefined;
    }
    else {
        const affPorts = affectedPorts;
        return new SimulationError(SimulationErrorType.UnnecessaryNC, undefined, map_1((port_2) => port_2.HostId, affPorts), map_1((conn_2) => conn_2.Id, filter((conn_1) => exists((port_3) => equals(port_3.Id, conn_1.Source.Id), affPorts), conns)));
    }
}

function checkConnectionsWidths(canvasState_, canvasState__1) {
    let err;
    const canvasState = [canvasState_, canvasState__1];
    const convertConnId = (_arg) => _arg;
    const matchValue = inferConnectionsWidth(canvasState[0], canvasState[1]);
    if (matchValue.tag === 0) {
        const connWidths = matchValue.fields[0];
        const faulty = filter_1((_arg_1, width) => (width == null), connWidths);
        if (FSharpMap__get_IsEmpty(faulty)) {
            return [undefined, connWidths];
        }
        else {
            return [new SimulationError(new SimulationErrorType(/* InferConnWidths */ 6, ["Could not infer all connections widths."]), undefined, empty(), map_1((tupledArg) => convertConnId(tupledArg[0]), toList(faulty))), undefined];
        }
    }
    else {
        return [(err = matchValue.fields[0], new SimulationError(new SimulationErrorType(/* WidthMismatch */ 5, [err]), undefined, empty(), map_1(convertConnId, err.ConnectionsAffected))), undefined];
    }
}

/**
 * check component labels are all unique and do not include protected values (CLK)
 */
export function checkComponentNamesAreOk(_arg1_, _arg1__1) {
    let tupledArg_3;
    const comps = _arg1_;
    const option_1 = tryHead(append(map_1((tupledArg) => [map_1((tuple_1) => tuple_1[0], tupledArg[1]), tupledArg[0]], List_groupBy((tuple) => tuple[1], collect((comp) => {
        const label = comp.Label.toLocaleUpperCase();
        switch (label) {
            case "CLK":
                return singleton([comp, "Clk is not allowed as a name for a component or a Net. Use the properties tab to give a different name to the highlighted component(s)."]);
            case "":
                return singleton([comp, "All components must have a unique alphanumeric name (e.g. \'G1\'). An empty name is not allowed except for split and join and bus select.Use the properties tab to give a non-empty name to the highlighted component(s)."]);
            default:
                return empty();
        }
    }, filter((_arg_1) => {
        switch (_arg_1.Type.tag) {
            case 27:
            case 28:
            case 6:
            case 4:
                return false;
            default:
                return true;
        }
    }, comps)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), map_1((tupledArg_2) => [tupledArg_2[1], "Component names must be distinct. Use the properties tab to give different names to the highlighted components"], filter((tupledArg_1) => (length(tupledArg_1[1]) > 1), List_groupBy((comp_1) => comp_1.Label, filter((_arg_2) => {
        switch (_arg_2.Type.tag) {
            case 3:
            case 52:
            case 53:
            case 27:
            case 28:
            case 6:
            case 4:
                return false;
            default:
                return true;
        }
    }, comps), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    })))));
    if (option_1 != null) {
        return (tupledArg_3 = option_1, new SimulationError(new SimulationErrorType(/* BadName */ 7, [tupledArg_3[1]]), undefined, map_1((comp_2) => comp_2.Id, tupledArg_3[0]), empty()));
    }
    else {
        return undefined;
    }
}

function checkArrayIOIsOnAnArraySheet(_arg1_, _arg1__1) {
    const _arg_1 = filter((comp) => {
        const matchValue = comp.Type;
        switch (matchValue.tag) {
            case 50:
            case 51:
            case 52:
            case 53:
                return true;
            default:
                return false;
        }
    }, _arg1_);
    if (isEmpty(_arg_1)) {
        return undefined;
    }
    else {
        const bad = _arg_1;
        return new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [concat(StringModule_Concat(", ", map_1((c) => concat("\'", c.Label, "\'"), bad)), " can only be used on an array component")]), undefined, map_1((c_1) => c_1.Id, bad), empty());
    }
}

/**
 * Analyse a CanvasState and return any error (or None).
 */
export function analyseState(state_, state__1, ldComps) {
    const state = [state_, state__1];
    const patternInput = checkConnectionsWidths(state[0], state[1]);
    return [flatten(tryFind_1((option) => (option != null), ofArray([checkPortTypesAreConsistent(state[0], state[1]), checkPortsAreConnectedProperly(state[0], state[1]), checkIOLabels(state[0], state[1]), checkArrayIOIsOnAnArraySheet(state[0], state[1]), checkCustomComponentsOk(state[0], state[1], ldComps), patternInput[0], checkComponentNamesAreOk(state[0], state[1]), checkAdderUnnecessaryNC(state[0], state[1])]))), patternInput[1]];
}

